import React, { Component } from 'react'
import { localize } from '../../util/Localizer'
import ContactUs from './ContactUs'
import About from './About'
import { connect } from 'react-redux'
import { toggleLanguage } from '../../redux/actions/languageActions'
import { injectIntl } from 'react-intl'
import Config from '../../Config'

import { push } from 'connected-react-router'

class TopNav extends Component {
  constructor () {
    super()
    this.setLang = this.setLang.bind(this)
    this.pushFaq = this.pushFaq.bind(this)
  }

  pushFaq (e) {
    e.preventDefault()
    this.props.push('/faq')
  }

  setLang (e) {
    e.preventDefault()
    this.props.toggleLanguage()
  }
  render () {
    const appContent = this.props.appContent && this.props.appContent.content
    const useLocale = Config.useLocale
    return (
      <div className='topNav navLinks'>
        {useLocale && <div>
          <a href='' id='setFrench' onClick={this.setLang}>{localize('common.nav.language')}</a>
        </div>}
        <ContactUs primary={this.props.primary} appContent={appContent.contact} />
        <div>
          <a href='' id='pushFaq' onClick={this.pushFaq}>{localize('common.contactus.faq')}</a>
        </div>
        <About primary={this.props.primary} appContent={appContent.about}/>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    appContent: state.AppContentReducer.appContent
  }
}
const ConnectedTopNav = connect(mapStateToProps, { toggleLanguage, push })(injectIntl(TopNav))

export default ConnectedTopNav



// WEBPACK FOOTER //
// ./src/widgets/common/TopNav.js